export default {
  name: "SlideUpDown",
  props: {
    active: Boolean,
    duration: {
      type: Number,
      default: 500
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  data: function data() {
    return {
      style: {},
      initial: !1
    };
  },
  watch: {
    active: function active() {
      this.layout();
    }
  },
  render: function render(t) {
    return t(this.tag, {
      style: this.style,
      ref: "container",
      attrs: {
        "aria-hidden": !this.active
      },
      on: {
        transitionend: this.onTransitionEnd
      }
    }, this.$slots.default);
  },
  mounted: function mounted() {
    this.layout(), this.initial = !0;
  },
  computed: {
    el: function el() {
      return this.$refs.container;
    }
  },
  methods: {
    layout: function layout() {
      var t = this;
      this.active ? (this.$emit("open-start"), this.initial && this.setHeight("0px", function () {
        return t.el.scrollHeight + "px";
      })) : (this.$emit("close-start"), this.setHeight(this.el.scrollHeight + "px", function () {
        return "0px";
      }));
    },
    asap: function asap(t) {
      this.initial ? this.$nextTick(t) : t();
    },
    setHeight: function setHeight(t, i) {
      var e = this;
      this.style = {
        height: t
      }, this.asap(function () {
        e.__ = e.el.scrollHeight, e.style = {
          height: i(),
          overflow: "hidden",
          "transition-property": "height",
          "transition-duration": e.duration + "ms"
        };
      });
    },
    onTransitionEnd: function onTransitionEnd() {
      this.active ? (this.style = {}, this.$emit("open-end")) : (this.style = {
        height: "0",
        overflow: "hidden"
      }, this.$emit("close-end"));
    }
  }
};